/**
 * 編集のステップ
 */
export const EDIT_STEP = {
  INPUT: 'input',
  CONFIRMATION: 'confirmation',
  DELETE: 'delete',
} as const;

/**
 * 編集のステップのコード値
 */
export type EditStep = typeof EDIT_STEP[keyof typeof EDIT_STEP];
